import {Subject} from 'rxjs';

import {UserProfileViewModel} from '../viewModels/userProfile.viewModel';

export class AuthEventsEmitter {
    private readonly tokenChanged: Subject<string> = new Subject();
    private readonly userProfileChanged: Subject<UserProfileViewModel> = new Subject();
    private readonly facebookIdChanged: Subject<string> = new Subject();

    tokenChanged$ = this.tokenChanged.asObservable();
    userProfileChanged$ = this.userProfileChanged.asObservable();
    facebookIdChanged$ = this.facebookIdChanged.asObservable();

    broadcastTokenChanged(token: string) {
        this.tokenChanged.next(token);
    }

    broadcastUserProfileChanged(userProfile: UserProfileViewModel) {
        this.userProfileChanged.next(userProfile);
    }

    broadcastFacebookIdChanged(facebookId: string) {
        this.facebookIdChanged.next(facebookId);
    }
}
